module.exports = __webpack_public_path__ + "img/advantage5Blue.593faefb.png";